class DashboardModel {
  constructor() {
    this.balance = {
      unallocated: null,
      available: null,
      acWalletWithdrawable: 0,
      totalRunningCommission: 0,
    };
    this.currency = null;
    this.verifiedAt = null;
    this.activatedAt = null;
    this.customerProducts = null;
    this.modal = '';
    this.status = null;

    //For now affiliate stats is not yet part of this feature.
    //We will uncomment this once they have decided to use the affiliate stats graph.
    /*this.statistics = {
      referralCount: 0,
      newCustomers: 0,
      customersWithDeposit: 0,
      activeCustomers: 0,
    };*/
  }

}

export default DashboardModel;



// WEBPACK FOOTER //
// ./client/app/pages/customer/dashboard/model/dashboard.model.js